import React from "react";
import { Modal, Tab, Nav, Button, Spinner } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { useMutation } from "react-query";
import * as Yup from "yup";
import { useBackendUrl } from "../utils/hooks";

const PaymentGatewayModal = ({ show, onHide, selectedBank }) => {
  const backendUrl = useBackendUrl();

  const saveGatewayData = async data => {
    const response = await fetch(`${backendUrl}/api/payment-gateway`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error("Failed to save data");
    return response.json();
  };

  const mutation = useMutation(saveGatewayData);

  const initialValues = {
    stripe: { apiKey: "", secretKey: "" },
    paypal: { clientId: "", clientSecret: "" },
    paystack: { publicKey: "", secretKey: "" },
    flutterwave: { publicKey: "", secretKey: "" },
  };

  const validationSchema = Yup.object({
    stripe: Yup.object({
      apiKey: Yup.string() /* .required("Required") */,
      secretKey: Yup.string() /* .required("Required") */,
    }),
    paypal: Yup.object({
      clientId: Yup.string() /* .required("Required") */,
      clientSecret: Yup.string() /* .required("Required") */,
    }),
    paystack: Yup.object({
      publicKey: Yup.string() /* .required("Required") */,
      secretKey: Yup.string() /* .required("Required") */,
    }),
    flutterwave: Yup.object({
      publicKey: Yup.string() /* .required("Required") */,
      secretKey: Yup.string() /* .required("Required") */,
    }),
  });

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <div>
          <Modal.Title className="h5">Setup Payment Gateways</Modal.Title>
          <p>
            {selectedBank.BankName} <small>({selectedBank.currency})</small>
          </p>
        </div>
      </Modal.Header>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          mutation.mutate(values, {
            onSuccess: () => {
              actions.setSubmitting(false);
              onHide();
            },
            onError: error => {
              console.error(error);
              actions.setSubmitting(false);
            },
          });
        }}
      >
        {({ values, errors, touched, handleChange, handleSubmit, isSubmitting }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Tab.Container defaultActiveKey="paystack">
                <Nav variant="tabs" className="mb-3">
                  <Nav.Item>
                    <Nav.Link eventKey="paystack">Paystack</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="stripe">Stripe</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="paypal">PayPal</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="flutterwave">Flutterwave</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="stripe">
                    <p>...</p>
                    {/*   <div className="mb-3">
                      <label className="form-label">API Key</label>
                      <Field name="stripe.apiKey" className="form-control" />
                      {errors.stripe?.apiKey && touched.stripe?.apiKey && (
                        <div className="text-danger">{errors.stripe.apiKey}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Secret Key</label>
                      <Field name="stripe.secretKey" className="form-control" />
                      {errors.stripe?.secretKey && touched.stripe?.secretKey && (
                        <div className="text-danger">{errors.stripe.secretKey}</div>
                      )}
                    </div> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="paypal">
                    <p>...</p>
                    {/*  <div className="mb-3">
                      <label className="form-label">Client ID</label>
                      <Field name="paypal.clientId" className="form-control" />
                      {errors.paypal?.clientId && touched.paypal?.clientId && (
                        <div className="text-danger">{errors.paypal.clientId}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Client Secret</label>
                      <Field name="paypal.clientSecret" className="form-control" />
                      {errors.paypal?.clientSecret && touched.paypal?.clientSecret && (
                        <div className="text-danger">{errors.paypal.clientSecret}</div>
                      )}
                    </div> */}
                  </Tab.Pane>
                  <Tab.Pane eventKey="paystack">
                    <div className="mb-3">
                      <label className="form-label">Public Key</label>
                      <Field name="paystack.publicKey" className="form-control" />
                      {errors.paystack?.publicKey && touched.paystack?.publicKey && (
                        <div className="text-danger">{errors.paystack.publicKey}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Secret Key</label>
                      <Field name="paystack.secretKey" className="form-control" type="password" />
                      {errors.paystack?.secretKey && touched.paystack?.secretKey && (
                        <div className="text-danger">{errors.paystack.secretKey}</div>
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="flutterwave">
                    <p>...</p>
                    {/* <div className="mb-3">
                      <label className="form-label">Public Key</label>
                      <Field name="flutterwave.publicKey" className="form-control" />
                      {errors.flutterwave?.publicKey && touched.flutterwave?.publicKey && (
                        <div className="text-danger">{errors.flutterwave.publicKey}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Secret Key</label>
                      <Field name="flutterwave.secretKey" className="form-control" />
                      {errors.flutterwave?.secretKey && touched.flutterwave?.secretKey && (
                        <div className="text-danger">{errors.flutterwave.secretKey}</div>
                      )}
                    </div> */}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? <Spinner animation="border" size="sm" /> : "Save Changes"}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default PaymentGatewayModal;
